import { LazyLoader, Modal } from '@bp/ui-components';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GroupForm } from '../forms/GroupForm';

type GroupModalProps = {
  isOpen: boolean;
  groupUuid: string | null;
  schoolYearUuid: string;
  page: 'groups' | 'institution';
  onClose: () => void;
};

export const GroupModal = ({ isOpen, groupUuid, schoolYearUuid, page, onClose }: GroupModalProps) => {
  const { t } = useTranslation();

  const headlines: string[] = [
    groupUuid && groupUuid !== '' ? t('groups.editGroup') : t('groups.addGroup'),
    t('groups.editEditors'),
    t('groups.collaborationOverview'),
  ];

  const [headline, setHeadline] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  function handleStep(step: number) {
    setHeadline(headlines[step]);
  }

  return (
    <Modal
      isOpen={isOpen}
      loading={loading}
      onRequestClose={() => {
        setHeadline('');
        onClose();
      }}
      title={headline}
    >
      <Suspense fallback={<LazyLoader embedded forceHeight='50vh' />}>
        <GroupForm
          groupUuid={groupUuid}
          schoolYearUuid={schoolYearUuid}
          page={page}
          onStep={handleStep}
          onLoad={setLoading}
          onClose={() => {
            setHeadline('');
            onClose();
          }}
        />
      </Suspense>
    </Modal>
  );
};
